import {Injectable} from '@angular/core';

export interface NavigationItem {
  id: string;
  title: string;
  type: 'item' | 'collapse' | 'group';
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  function?: any;
  badge?: {
    title?: string;
    type?: string;
  };
  children?: Navigation[];
}

export interface Navigation extends NavigationItem {
  children?: NavigationItem[];
}

const NavigationItems = [
  {
    id: 'navigation',
    title: 'Navigation',
    type: 'group',
    icon: 'feather icon-monitor',
    children: [
      {
        id: 'user-home',
        title: 'User Management',
        type: 'collapse',
        icon: 'feather icon-home',
        children: [
          {
            id: 'default',
            title: 'Dashboard',
            type: 'item',
            url: '/dashboard/default'
          },
          {
            id: 'branch',
            title: 'Branch',
            type: 'item',
            url: '/layout/horizontal',
            target: true
          },
          {
            id: 'staff',
            title: 'Staff Account',
            type: 'item',
            url: '/dashboard/sale'
          },
          {
            id: 'account-transfer',
            title: 'Transfer Account',
            type: 'item',
            url: '/dashboard/crm'
          },
          {
            id: 'acount-freeze',
            title: 'Freeze Account',
            type: 'item',
            url: '/dashboard/analytics'
          },
        ]
      },
      {
        id: 'crm',
        title: 'CRM',
        type: 'collapse',
        icon: 'feather icon-layout',
        children: [
          {
            id: 'default',
            title: 'Dashboard',
            type: 'item',
            url: '/dashboard/default'
          },
          {
            id: 'debtors-account',
            title: 'Debtors Account',
            type: 'item',
            url: '/layout/horizontal',
            target: true
          },
          {
            id: 'depositors-account',
            title: 'Depositors Account',
            type: 'item',
            url: '/layout/horizontal-l2',
            target: true
          },
          {
            id: 'horizontal-rtl',
            title: 'Horizontal RTL',
            type: 'item',
            url: '/layout/horizontal-rtl',
            target: true
          },
          {
            id: 'box-layout',
            title: 'Box Layout',
            type: 'item',
            url: '/layout/box',
            target: true
          },
          {
            id: 'light-layout',
            title: 'Light Layout',
            type: 'item',
            url: '/layout/light',
            target: true
          },
          {
            id: 'dark-layout',
            title: 'Dark Layout',
            type: 'item',
            url: '/layout/dark',
            target: true,
            badge: {
              title: 'Hot',
              type: 'badge-danger'
            }
          },
          {
            id: 'red-layout',
            title: 'Red Layout',
            type: 'item',
            url: '/layout/red',
            target: true,
            badge: {
              title: 'Hott',
              type: ''
            }
          }
        ]
      },
      {
        id: 'inventory',
        title: 'Inventory',
        type: 'collapse',
        icon: 'feather icon-layers',
        children: [
          {
            id: 'default',
            title: 'Dashboard',
            type: 'item',
            url: '/dashboard/default'
          },
          {
            id: 'statistic',
            title: 'Statistic',
            type: 'item',
            url: '/widget/statistic'
          },
          {
            id: 'data',
            title: 'Data',
            type: 'item',
            url: '/widget/data'
          },
          {
            id: 'chart',
            title: 'Chart',
            type: 'item',
            url: '/widget/chart'
          }
        ]
      },
      {
        id: 'settings',
        title: 'Settings',
        type: 'collapse',
        icon: 'feather icon-settings',
        children: [
          {
            id: 'profile',
            title: 'Profile',
            type: 'item',
            url: '/users/profile',
            breadcrumbs: false
          },
          {
            id: 'cards',
            title: 'User Card',
            type: 'item',
            url: '/users/card'
          },
          {
            id: 'list',
            title: 'User List',
            type: 'item',
            url: '/users/list'
          }
        ]
      },
      {
        id: 'session',
        title: 'Session',
        type: 'collapse',
        icon: 'feather icon-settings',
        children: [
          {
            id: 'open-session',
            title: 'Start Session',
            type: 'item',
            url: '/users/profile',
            breadcrumbs: false
          },
          {
            id: 'close-session',
            title: 'Close Session',
            type: 'item',
            url: '/users/card'
          },
          {
            id: 'reopen-session',
            title: 'Reopen Session',
            type: 'item',
            url: '/users/list'
          }
        ]
      }
    ]
  }
];

@Injectable()
export class NavigationItem {
  public get() {
    return NavigationItems;
  }
}
